import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SignaturePad } from "../components/SignaturePad";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/consentement`;

/** Page publique : lecture + signature de l'autorisation photos/vidéos (lien reçu par courriel ou SMS). */
export default function ConsentementPublic() {
  const { token } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  const [signataire, setSignataire] = useState("");
  const [sig, setSig] = useState("");
  const [accepte, setAccepte] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    axios.get(`${API}/${token}`).then((r) => { setC(r.data); setSignataire(r.data.mineur ? r.data.parent_nom || "" : r.data.nom || ""); if (r.data.statut === "signe") setDone(r.data.signe_at); })
      .catch((e) => setErr(e?.response?.data?.detail || "Lien invalide"));
  }, [token]);

  const signer = async () => {
    setBusy(true); setErr("");
    try { const r = await axios.post(`${API}/${token}/signer`, { signataire, signature_png: sig, accepte }); setDone(r.data.signe_at); }
    catch (e) { setErr(e?.response?.data?.detail || "Signature impossible"); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#f6f3ec] text-zinc-900 px-4 py-8" data-testid="consentement-public">
      <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-lg border border-zinc-200 p-6 sm:p-8 space-y-5">
        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-amber-600 font-bold">Institut Impact Élite Martial · Val-d'Or</div>
          <h1 className="text-2xl sm:text-3xl font-black mt-1">Autorisation photos et vidéos</h1>
        </div>
        {err && !c && <p className="text-red-600 text-sm" data-testid="consentement-erreur">{err}</p>}
        {c && (
          <>
            <p className="text-sm text-zinc-600">Personne concernée : <b className="text-zinc-900" data-testid="consentement-nom">{c.nom}</b>{c.mineur && <> (mineur — signature du parent ou tuteur <b>{c.parent_nom}</b>)</>}</p>
            <div className="rounded-xl bg-zinc-50 border border-zinc-200 p-4 text-sm leading-relaxed" data-testid="consentement-texte">{c.texte}</div>
            <ul className="text-sm text-zinc-700 list-disc pl-5">{c.portees.map((p) => <li key={p}>{p}</li>)}</ul>
            {done ? (
              <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-4 text-emerald-800 text-sm" data-testid="consentement-merci"><b>Merci !</b> Autorisation signée le {new Date(done).toLocaleString("fr-CA")}. Vous pouvez la retirer en tout temps en écrivant au dojo.</div>
            ) : (
              <div className="space-y-4">
                <label className="block text-sm">Nom du signataire<input data-testid="consentement-signataire" className="mt-1 w-full rounded-lg border border-zinc-300 px-3 py-2" value={signataire} onChange={(e) => setSignataire(e.target.value)} /></label>
                <SignaturePad onChange={setSig} />
                <label className="flex items-start gap-3 text-sm"><input type="checkbox" data-testid="consentement-accepte" className="mt-1 w-5 h-5 accent-amber-500" checked={accepte} onChange={(e) => setAccepte(e.target.checked)} /><span>J'ai lu l'autorisation ci-dessus et j'accepte{c.mineur ? ", en tant que parent ou tuteur," : ""} l'utilisation des photos et vidéos aux fins indiquées.</span></label>
                {err && <p className="text-red-600 text-sm" data-testid="consentement-erreur">{err}</p>}
                <button type="button" disabled={busy || !accepte || !sig || !signataire.trim()} onClick={signer} data-testid="consentement-signer" className="w-full rounded-full bg-amber-500 hover:bg-amber-400 disabled:opacity-40 text-zinc-950 font-bold py-3">{busy ? "Envoi…" : "Signer l'autorisation"}</button>
                <p className="text-xs text-zinc-500">Vous pouvez refuser : il suffit de ne pas signer. Aucune image ne sera utilisée sans cette autorisation.</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
